module.exports = __webpack_public_path__ + "img/3.4ddfdc29.jpg";